import axios from "axios";
export const premiumSdk = axios.create({
  baseURL: "/api/premium",
  headers: {
    "x-premium-secret": process.env.PROVIDER_PREMIUM_SECRET as string,
  },
});
